module.exports = __webpack_public_path__ + "img/part1.6fa58916.jpeg";